import { useEffect, useState } from "react";
import api from "api/api";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components

import { CircularProgress } from "@mui/material";

//import assets
import interviewRespondents from "../../../assets/Interview-respondants.png";
import brandImg from "../../../assets/brands.png";
import competitorImg from "../../../assets/competitor.png";
import matchedImg from "../../../assets/matched.png";
import unmatchedImg from "../../../assets/unmatched.png";

// import helper

import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";
const dashboardLabel = [
    {
        title: "No. of Respondents",
        image: interviewRespondents,
        value: "respondents",
    },
    {
        title: "Unilever Products",
        image: brandImg,
        value: "unileverProduct",
    },
    {
        title: "Benchmark Products",
        image: competitorImg,
        value: "competitorProduct",
    },
    {
        title: "Products having Matches",
        image: matchedImg,
        value: "matchedProducts",
    },
    {
        title: "Products having No Matches",
        image: unmatchedImg,
        value: "unmatchedProducts",
    },
    
];

function DashboardPanel({ selectedProducts = [] }) {
    const dispatch = useDispatch();   
    const [data, setData] = useState({
        respondents: 0,
        unileverProduct: 0,
        competitorProduct: 0,
        matchedProducts: 0,
        unmatchedProducts: 0,        
    });
    const [progress, setProgress] = useState(false);
    const algorithm = useSelector((state) => state.matchNetStore.selectedStudyType);
    // const updateSummary = useCallback((res) => {
    //     setData((prevState) => ({
    //         ...prevState,
    //         respondents: res.data.no_of_respondents,
    //         unileverProduct: res.data.unilever_products,
    //         competitorProduct: res.data.benchmark_products,
    //         matchedProducts: res.data.products_having_matches,
    //         unmatchedProducts: res.data.products_having_no_matches,
    //     }));
    // }, []);

    // useEffect(() => {
    //     coreDataIds.length > 0 && setProgress(true);
    //     const fetchData = setTimeout(async () => {
    //         if (coreDataIds.length > 0) {
    //             try {
    //                 const url = process.env.REACT_APP_SERVER_PATH + `/study-datas/study-count/?archive=false&return_respondent=true&core_data_model_id=${coreDataIds}`;
    //                 await api
    //                     .get(url)
    //                     .then(async (res) => {
    //                         updateSummary(res, selectedStudy);
    //                         setProgress(false);
    //                     })
    //                     .catch((error) => {
    //                         handleError(error);
    //                         setProgress(false);
    //                     });
    //             } catch (error) {
    //                 handleError(error);
    //                 setProgress(false);
    //             }
    //         } else {
    //             setData({
    //                 respondents: 0,
    //                 unileverProduct: 0,
    //                 competitorProduct: 0,
    //                 matchedProducts: 0,
    //                 unmatchedProducts: 0,  
    //             });
    //         }
    //     }, 1000);
    //     return () => {
    //         clearTimeout(fetchData);
    //         setProgress(false);
    //     };
    // }, [coreDataIds, selectedStudy, updateSummary]);

    useEffect(() => {
        if (selectedProducts.length > 0) {
            setProgress(true);
            const payload = {
                algorithm: algorithm,
                products: selectedProducts.map((ele) => ({
                    core_data_model_id: ele.core_data_id,
                    product_code: ele.product_match,
                })),
            };
            const coreDataIds = [
                ...new Set(selectedProducts.map((ele) => ele.core_data_id))
            ].join(",");
            // const productCodes = [
            //     ...new Set(selectedProducts.map((ele) => ele.product_match))
            // ].join(",");
            if (coreDataIds.length > 0) {
                try {
                    const url = process.env.REACT_APP_SERVER_PATH + `/deodrants-match-net-analysis/dashboard/`;
                    api
                        .post(url, payload)
                        .then(async (res) => {
                            // updateSummary(res);
                            setData({
                                respondents: res.data.no_of_respondents,
                                unileverProduct: res.data.unilever_products,
                                competitorProduct: res.data.benchmark_products,
                                matchedProducts: res.data.products_having_matches,
                                unmatchedProducts: res.data.products_having_no_matches,
                            });
                            setProgress(false);
                        })
                        .catch((error) => {
                            handleError("error", error);
                            setProgress(false);
                        });
                } catch (error) {
                    handleError("error", error);
                    setProgress(false);
                }
            } else {
                setData({
                    respondents: 0,
                    unileverProduct: 0,
                    competitorProduct: 0,
                    matchedProducts: 0,
                    unmatchedProducts: 0,  
                });
                setProgress(false);
            }
        } else {
            setData({
                respondents: 0,
                unileverProduct: 0,
                competitorProduct: 0,
                matchedProducts: 0,
                unmatchedProducts: 0,  
            });
        }
    }, [selectedProducts, algorithm]);

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    return (
        <>
            {dashboardLabel &&
                dashboardLabel.map((ele) => {
                    return (
                        <div
                            key={ele.value}
                            className="remove-opacity box-shadow--full-container"
                            style={{
                                backgroundColor: "#FFFFFF",
                                padding: "5px",
                                color: "#005eef",
                                borderRadius: "5px",
                                fontSize: "10px",
                                fontWeight: "600",
                                marginTop: "10px",
                                marginBottom: "20px",
                            }}
                        >
                            <div className={"filter-img-box "}>
                                <img
                                    src={ele.image}
                                    alt={ele.value}
                                    style={{
                                        width: "170px",
                                        height: "95px",
                                        marginBottom: 5,
                                    }}
                                />
                            </div>
                            <span
                                style={{
                                    textShadow: "rgb(255, 255, 255) 0px 0px 10px, rgba(255, 71, 217, 0) 11px -1px 12px",
                                }}
                            >
                                <span>{ele.title}</span>
                                <span
                                    style={{
                                        position: "absolute",
                                        right: "5px",
                                    }}
                                >
                                    {progress ? (
                                        <CircularProgress
                                            sx={{ color: "#005EEF", marginRight: "5px" }}
                                            size={12}
                                        />
                                    ) : (
                                        data[ele.value]
                                    )}
                                </span>
                            </span>
                        </div>
                    );
                })}
        </>
    );
}

DashboardPanel.propTypes = {
    selectedProducts: PropTypes.array,
};

export default DashboardPanel;
